import React, { useEffect, useState } from 'react'

const ThidFooter = () => {
  return (
    <>
      <footer className="third-footer d-flex justify-content-around align-items-center">
        <p className="text-white">© 2024 created by Mu7areb</p>
        <img
          src="https://res.cloudinary.com/dhlgqavcx/image/upload/v1702818572/payment_qvmdvi.png"
          alt="payment Img"
        />
      </footer>
    </>
  )
}

export default ThidFooter
